<template>
	<section class="m-report-page header-margin">
		<heading
			:title="report.report_info.title"
			:date="report.report_info.date"
			:report_file="report.report_info.report_file"
		></heading>
	</section>
	<section class="m-report-page">
		<list-widget
			:list="report.report_info.detail_text"
			:widget="report.widget"
		></list-widget>
	</section>

	<charts
		:product="report.products"
		:programs="report.gov_programs"
		:limit="report.report_info.limit_chart"
	></charts>

	<mortgage-portfolio
		:data="report.portfolio_dynamics"
		:file="report.report_info.report_file"
	></mortgage-portfolio>

	<report-period :report_id="report.report_info.id"></report-period>
</template>

<script>
import Heading from './Heading.vue'
import ListWidget from './ListWidget.vue'
import Charts from './Charts.vue'
import MortgagePortfolio from './MortgagePortfolio.vue'
import ReportPeriod from './ReportPeriod.vue'
export default {
	name: 'MortgageMarketReport',
	components: { Heading, ListWidget, MortgagePortfolio, ReportPeriod, Charts },
	mixins: [],
	props: {
		dataId: {
			type: String,
		},
		report: {
			type: Object,
		},
	},
	data() {
		return {}
	},
	mounted() {},
	computed: {},
	methods: {},
}
</script>
